export function findMenu(menu, route) {
  let foundMenu = undefined;
  let found = undefined;
  let splittedMenu = undefined;

  menu.forEach(item => {
    const subMenu = item.get('subMenu');

    if (subMenu && !subMenu.isEmpty()) {
      const foundSubmenu = findMenu(subMenu, route);

      if (foundSubmenu.item) {
        foundMenu = item;
        found = foundSubmenu.item;

        return false;
      }
    }

    if (
      (route === item.get('route') && !item.get('urlAuxiliar')) ||
      route === `${item.get('route')}${item.get('urlAuxiliar')}`
    ) {
      foundMenu = subMenu;
      found = item;
      return false;
    }

    splittedMenu = item.get('route') && item.get('route').split('/');
    if (splittedMenu && route === splittedMenu[1]) {
      found = item;
      foundMenu = subMenu;
      return false;
    }
  });

  return {
    menu: foundMenu,
    item: found
  };
}
